import { Box, Grid } from '@mui/material';
import BlockProps from '../../../models/BlockProps';
import Utils from '../../../utils/Utils';
import ImageModal from '../../Modals/ImageModal/ImageModal';
import ImageComponent from '../../ImageComponent';
import { BlockAnimationBlockData } from './BlockAnimationBlockData';
import EditableText from '../../Form/EditableText';
import CloseButton from '../../Buttons/Close';

const BlockAnimationBlock = (props: BlockProps) => {
  const {
    isEditing, isTemplate, data, editHandler,
  } = props;
  const blockData = data.data as BlockAnimationBlockData;
  const {
    imgLeft, imgRight, text1, text2,
  } = blockData;

  const { id } = data;

  return (
<Grid container flexDirection="column" gap={3}>
        <Grid item container flexDirection="row" justifyContent="space-evenly" rowGap={3}>
            {imgLeft && (
<Grid item className="animation-block-slide-from-left" maxWidth="40%" sx={Utils.hoverBorder(isEditing)}>
                    {isEditing && (
<CloseButton updateHandler={() => {
  delete blockData.imgLeft;
  editHandler(id, blockData);
}}
/>
                    )}
                    <ImageModal
                      disabled={isTemplate || !isEditing}
                      images={[]}
                      handleOnConfirm={(url: string) => {
                        blockData.imgLeft.value = url;
                        editHandler(id, blockData);
                      }}
                    >
                        <ImageComponent src={imgLeft.value} />
                    </ImageModal>
</Grid>
            )}

            {imgRight && (
<Grid item className="animation-block-slide-from-right" maxWidth="40%" sx={Utils.hoverBorder(isEditing)}>
                {isEditing && (
<CloseButton updateHandler={() => {
  delete blockData.imgRight;
  editHandler(id, blockData);
}}
/>
                )}
                <ImageModal
                  disabled={isTemplate || !isEditing}
                  images={[]}
                  handleOnConfirm={(url: string) => {
                    blockData.imgRight.value = url;
                    editHandler(id, blockData);
                  }}
                >
                    <ImageComponent src={imgRight.value} />
                </ImageModal>
</Grid>
            )}
        </Grid>

        <Grid className="animation-block-slide-up" item container flexDirection="column" gap={3}>
            {text1 && (
<Grid
  container
  item
  xs={12}
  justifyContent="center"
>
          <Box sx={Utils.hoverBorder(isEditing)} width="60%">

            {isEditing && (
              <CloseButton updateHandler={() => {
                delete blockData.text1;
                editHandler(id, blockData);
              }}
              />
            )}

            <EditableText
              text={text1.value}
              isEditable={isEditing && !isTemplate}
              updateHandler={() => {

              }}
            />
          </Box>
</Grid>
            )}

        {text2 && (
<Grid
  container
  item
  xs={12}
  flexDirection="row"
  justifyContent="center"
  className="animation-block-slide-up"
>
          <Box sx={Utils.hoverBorder(isEditing)} width="60%">

            {isEditing && (
              <CloseButton updateHandler={() => {
                delete blockData.text2;
                editHandler(id, blockData);
              }}
              />
            )}

            <EditableText
              text={text2.value}
              isEditable={isEditing && !isTemplate}
              updateHandler={() => {

              }}
            />
          </Box>
</Grid>
        )}

        </Grid>
</Grid>
  );
};

export default BlockAnimationBlock;
